"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BSNeo3Helper = void 0;
const common_json_1 = __importDefault(require("../assets/tokens/common.json"));
const BSNeo3Constants_1 = require("../constants/BSNeo3Constants");
class BSNeo3Helper {
    static getTokens(network) {
        var _a;
        const extraTokens = (_a = BSNeo3Constants_1.BSNeo3Constants.EXTRA_TOKENS_BY_NETWORK_ID[network.id]) !== null && _a !== void 0 ? _a : [];
        return [...extraTokens, ...common_json_1.default];
    }
    static getRpcList(network) {
        var _a;
        return (_a = BSNeo3Constants_1.BSNeo3Constants.RPC_LIST_BY_NETWORK_ID[network.id]) !== null && _a !== void 0 ? _a : [];
    }
    static isMainnet(network) {
        return BSNeo3Constants_1.BSNeo3Constants.MAINNET_NETWORK_IDS.includes(network.id);
    }
    static isCustomNet(network) {
        return !BSNeo3Constants_1.BSNeo3Constants.ALL_NETWORK_IDS.includes(network.id);
    }
    static normalizeHash(hash) {
        return hash.startsWith('0x') ? hash.slice(2) : hash;
    }
}
exports.BSNeo3Helper = BSNeo3Helper;
